import React from 'react'

import { Box, Checkbox, Typography } from '@material-ui/core'

const CreditCardCheckbox = ({ id, image, description, ...rest }) => {
  return (
    <Box display="flex" alignItems="center" component="label" htmlFor={id}>
      <Checkbox id={id} {...rest} />

      <Box
        display={{ xs: 'none', sm: 'block' }}
        width={60}
        borderRadius={8}
        mr={2}
        component="img"
        src={image}
        alt={description}
      />

      <Typography color="textSecondary">
        <Box component="span" fontWeight="fontWeightMedium">
          {description}
        </Box>
      </Typography>
    </Box>
  )
}

export default CreditCardCheckbox
